import { useTimeOnPageContext } from "contexts/time-on-page";
import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { AmplitudePageName } from "utils/amplitude";

const AMPLITUDE_PAGE_NAME: AmplitudePageName =
  "healthcare-provider-payment-policies";

const Policies = () => {
  const { setPage } = useTimeOnPageContext();
  useEffect(() => setPage(AMPLITUDE_PAGE_NAME), [setPage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={"m-5"}>
      <Container fluid>
        <h3 className="text-center">
          <u>Healthcare Provider Payment Policies</u>
        </h3>
        <p>September 2, 2020</p>
        <p>
          By registering to be listed and available for bookings as a Health
          Professional on Orchid ("the website," "website," "Orchid.Exchange"),
          you (&ldquo;Healthcare Provider&rdquo;, &ldquo;Independent
          Contractor&rdquo;) agree that the following terms and conditions will
          govern all payments made to you by Orchid members through the Orchid
          system.
        </p>
        <p>
          <strong>
            Conditions for Guaranteeing Receipt of Payment for Health Sessions
          </strong>
        </p>
        <p>
          Orchid is a marketplace for those seeking behavioral health services
          to connect with those seeking to provide behavioral health services.
          Orchid also provides a service to its users whereby payments will be
          distributed to Healthcare Providers that originate from their users.
        </p>
        <p>
          Orchid offers Healthcare Providers a layer of protection in the
          collection of their funds but, if any of the following conditions are
          not met and Orchid becomes unable to collect your payment from the
          Orchid member, or other type of account-holder (collectively,
          "member") to whom you gave a session, Orchid cannot guarantee that
          your payment will be successfully collected, processed, and
          distributed to you:
        </p>
        <ol className="lower-alpha">
          <li>
            The information pertaining to the session is accurate. This includes
            the start and end time, duration, and member name. Unless otherwise
            agreed to by the Healthcare Provider and member, the start and end
            time will be considered to be the times of the actual scheduled
            session, not arrival and departure times to and from the session
            location.
          </li>
          <li>
            Prior to each session being given, the member has on file with
            Orchid a valid form of payment. This includes a valid credit/debit
            card. The Healthcare Provider can view the status of the member's
            payment information through the Healthcare Provider's Orchid
            account. The requirement to verify payment information must be
            followed for continuing members as well as new members.
          </li>
          <li>
            The session is delivered in-person at a mutually agreed upon
            location or through the Orchid&rsquo;s platform. If the session is
            delivered remotely through another medium, such as via the internet,
            email, telephone, Skype, Zoom, or other video or voice conference
            service, the Healthcare Provider must obtain written confirmation
            from the member that acknowledges the nature of the work to be done
            and the expectations of the time and cost required to complete the
            work.
          </li>
          <li>
            The Healthcare Provider does not collect or request payment directly
            from the member by cash, check, or otherwise, for the session.
          </li>
          <li>
            For&nbsp;cancellation fees&nbsp;assessed to a member,&nbsp;the
            cancellation penalty is consistent with the cancellation policy
            explained directly to the member via Orchid&rsquo;s platform prior
            to the occurrence of the cancellation and also, where applicable, is
            consistent with the public display on the Healthcare
            Provider&rsquo;s profile. All session cancellations are subject to
            the standard 5% service fee.
          </li>
          <li>
            The Healthcare Provider is over 18 years old and is eligible to work
            in the United States.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>
          <strong>Timing and delivery of payments</strong>
        </p>
        <p>
          If all the&nbsp;
          <em>
            Conditions for guaranteeing receipt of payment for member sessions
          </em>
          &nbsp;are met, Healthcare Providers can expect to receive their funds
          according to the following schedule. If there are questions about any
          of the conditions, payments may be delayed while Orchid attempts to
          resolve such questions.
          <br />{" "}
        </p>
        <ol className="lower-alpha">
          <li>
            Healthcare Providers using the Orchid platform will receive their
            member payment by Direct Deposit via Stripe Connect. Funds from
            Stripe Connect will be released to the Healthcare Provider's bank on
            the 1st and 15th of each month or the following business day in case
            of weekends and bank holidays. In order for a session payment to be
            included during a particular period in which funds are disbursed,
            that session must be entered 5 days prior to the payment date. The
            time between when the funds are released by Orchid and made
            available to the Healthcare Provider by the Healthcare Provider's
            bank will vary and is controlled by the Healthcare Provider's bank,
            not by Orchid. If a Healthcare Provider's direct deposit is returned
            to Orchid by the Healthcare Provider's bank, Orchid will request
            that the Healthcare Provider correct the Healthcare Provider&rsquo;s
            bank information. The returned funds will be resent within five (5)
            days after the bank information is corrected.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>
          <strong>Social Security Number Requirement</strong>
        </p>
        <ol className="lower-alpha">
          <li>
            Prior to payments, Health Providers must submit to Stripe a valid
            Social Security Number ("SSN"). Such payments will be withheld by
            Orchid until the SSN is received, and the payments will be released
            with the next scheduled payment. (Although the burden to report 1099
            income and meet other state-level reporting requirement is
            technically on the member who is hiring and retaining you, Orchid
            offers members this filing service as a benefit of using the Orchid
            platform. To complete these filings, Stripe needs to have a valid
            SSN.)
          </li>
          <li>
            Healthcare Providers may use an Employer Identification Number
            ("EIN") issued by the Internal Revenue Service in place of an SSN
            for payment reporting purposes only.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>
          <strong>Calculation of Healthcare Provider Payment Amounts</strong>
        </p>
        <ol className="lower-alpha">
          <li>
            Healthcare Providers set their own hourly rate and may change it at
            any time. Changing the default hourly rate will affect users who
            contact a Healthcare Provider after the time the change is made.
          </li>
        </ol>
      </Container>
    </div>
  );
};

export default Policies;
